import { t } from "@/i18n-js/instance";
import type {
  SpaceAccessDetails,
  SpaceGroupAccessDetails,
} from "@circle-react/types/AccessRegistry";
import { AccordionV2 } from "@circle-react-uikit/AccordionV2";

export interface ContentSpecAccessGroupsProps {
  contentSpecAccessDetails: SpaceGroupAccessDetails | SpaceAccessDetails;
}

const i18nRoot =
  "settings.access_registry.components.content_spec_access_groups";

export const ContentSpecAccessGroups = ({
  contentSpecAccessDetails,
}: ContentSpecAccessGroupsProps) => {
  const accessGroupsCount = contentSpecAccessDetails.access_groups.length;
  if (accessGroupsCount === 0) {
    return null;
  }

  return (
    <AccordionV2
      title={t([i18nRoot, "title"], {
        count: accessGroupsCount,
      })}
      defaultExpanded={accessGroupsCount <= 2}
    >
      <AccordionV2.BulletedList
        items={contentSpecAccessDetails.access_groups.map(
          accessGroup => accessGroup.name,
        )}
      />
    </AccordionV2>
  );
};
